import React from 'react'
import Box from '@mui/material/Box'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined'

import { StepIcon, Text } from './wizard-common'
import CustomButton from '../../../components/custom-button'

export function WizardStepWelcome({
    nextStep,
}: {
    nextStep: () => void
}) {
    const ICON_STYLE = {
        position: 'relative',
        left: '-14px',
    }

    return (
        <Box>
            <StepIcon icon={<SettingsOutlinedIcon />} color="#DFF2E1" />

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4rem',
                }}
            >
                <Box>
                    <Text isHeader>Vítejte v průvodci rychlého nastavení!</Text>
                    <Text>
                        Upozornění: aplikace Chytrý Bojler momentálně není vhodná pro kombinované bojlery s ohřevem tepelným čerpadlem.
                        Kombinované bojlery s ohřevem z kotle na tuhá paliva, plynového kotle či z termálních solárních článků lze řídit pouze v obdobích,
                        kdy je elektrický ohřev hlavním zdrojem energie bojleru a částečně v přechodných obdobích.
                    </Text>
                    <Box sx={{ height: '1rem' }} /> {/* Prázdný řádek */}
                    <Text>
                        Nastavení Vám zabere přibližně 10 minut. Než začneme, připravte si prosím následující:
                    </Text>

                    <List>
                        <ListItem key="1">
                            <PeopleAltOutlinedIcon sx={ICON_STYLE} />
                            <Box sx={{}}>
                                <Text sx={{ display: 'inline-block' }}>
                                    Tuya/Shelly zásuvku či spínač připojený do originální aplikace výrobce
                                </Text>{' '}
                                (Tuya zařízení přes{' '}
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.tuya.smart&hl=cs"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Tuya Smart
                                </a>
                                , Shelly zařízení přes{' '}
                                <a
                                    href="https://play.google.com/store/search?q=shelly&c=apps&hl=cs"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Shelly Smart Control
                                </a>
                                ).
                                <Text sx={{ display: 'inline-block' }}>
                                    Pokud ještě zásuvku nemáte, doporučujeme zakoupit Tuya zásuvku {' '}
                                    <a
                                        href="https://www.immax.cz/immax-neo-lite-smart-vnitrni-zasuvka-v2-s-kolikem-typ-e-wifi-p15497/?cid=1505"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Immax NEO LITE v2
                                    </a>
                                    {' '}ze stránek výrobce s 20% slevovým kódem CHYTRYBOJLER. Další podporované spínače najdete na webu {' '}
                                    <a
                                        href="https://chytrybojler.cz/#sec-plugs"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        chytrybojler.cz/#sec-plugs.
                                    </a>
                                </Text>{' '}
                            </Box>
                        </ListItem>
                        <ListItem key="2">
                            <ReceiptLongOutlinedIcon sx={ICON_STYLE} />
                            <Text>Poslední vyúčtování elektřiny</Text>
                        </ListItem>
                        <ListItem key="3">
                            <PhotoCameraOutlinedIcon sx={ICON_STYLE} />
                            <Text>Ofocený štítek vašeho bojleru</Text>
                        </ListItem>
                    </List>
                </Box>

                <Box display="flex" justifyContent="right" mt={2}>
                    <CustomButton
                        text="Pokračovat"
                        type="submit"
                        onClick={() => {
                            nextStep()
                        }}
                    />
                </Box>
            </Box>
        </Box>
    )
}
